import { render, staticRenderFns } from "./CertificateHelperDialog.vue?vue&type=template&id=8f0ca45c"
import script from "./CertificateHelperDialog.vue?vue&type=script&lang=ts"
export * from "./CertificateHelperDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports